export const DEFAULT_HELP_LINK = 'mailto:support@movingworlds.org';

export const ORG_TSH_FAQ_LINK =
  'https://zsupport.movingworlds.org/portal/en/kb/movingworlds-faqs/social-enterprise-faqs/transform-support-hub-faqs-for-social-enterprises';
export const ORG_DIVERSE_SUPPLIER_FAQ_LINK =
  'https://movingworlds.org/partner/unilever/diverse-supplier-faqs';
export const ORG_DEFAULT_FAQ_LINK =
  'https://zsupport.movingworlds.org/portal/en/kb/movingworlds-faqs/social-enterprise-faqs/host-an-experteer';
